module.exports = __webpack_public_path__ + "img/iTunesArtwork.3c962492.png";